<template>
    <!--弹窗-->
    <el-dialog
        width="85%"
        class="plural"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
        top="5vh"
    >
        <div style="display: flex;justify-content: space-between;">

            <el-button icon="el-icon-refresh" @click="getList" size="mini" style="width: 40px;height: 40px;"></el-button>

            <el-button type="primary" @click="getNew" :loading="newLoading" style="margin-bottom: 20px;" size="mini">获取最新</el-button>

        </div>
        <el-table v-loading="loading" :data="list" size="mini" border height="700">
            <el-table-column prop="id" label="ID" align="center"/>
            <el-table-column prop="add_time" label="创建时间" width="150" align="center"/>
            <el-table-column label="状态标记" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row.status == 0 ? '待生成' : scope.row.status == 1 ? '生成中' : scope.row.status == 2 ? '' : '生成失败'
                        }}
                    </div>
                    <el-button type="success" @click="downFile(scope.row.parsing_path)"
                               size="mini" v-show="scope.row.status==2">下载</el-button>
                </template>
            </el-table-column>

            <el-table-column prop="parsing_err_msg	" label="文件出错备注信息" width="150" align="center"/>
            <el-table-column prop="parse_time" label="生成时间" width="150" align="center"/>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                @click="handleClose">关 闭
            </el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {traffic_word_create_excel_file, traffic_word_download_excel_list} from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'

export default {
    data() {
        return {
            id: undefined,
            loading: false,
            newLoading: false,
            list: [],
            keyword: '',
            query: {
                page: 1,
                limit: 10,
                total: 0,
            },
            visible: false
        }
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    methods: {
        showModal(id) {
            this.query = {
                page: 1,
                limit: 10,
                total: 0,
            }
            this.id = id
            this.queryList()
            this.visible = true

        },
        getNew() {
            this.newLoading = true
            api.traffic_word_create_excel_file({list_id: this.id}).then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.queryList()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).finally(() => {
                this.newLoading = false
            })
        },
        queryList() {
            this.query.page = 1
            this.getList()
        },
        getList() {
            this.loading = true
            this.query.list_id = this.id
            api.traffic_word_download_excel_list(this.query)
                .then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.list = res.data.list
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        // 关闭弹窗
        handleClose() {
            this.visible = false
            this.list = []
            this.$emit('close-callback', false)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.plural {
    /deep/ .el-table__empty-block {
        border-bottom: 1px #ebeef5 solid;
    }

    /deep/ .el-dialog__body {
        padding-top: 0 !important;
    }
}
</style>
